import { render, staticRenderFns } from "./ui-tabs.vue?vue&type=template&id=7de67518&"
import script from "./ui-tabs.vue?vue&type=script&lang=js&"
export * from "./ui-tabs.vue?vue&type=script&lang=js&"
import style0 from "./ui-tabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports